var civicCookieConfig = {
    Config: function (lang, gtagCode) {
        return {
            apiKey: '6a143dc9a280abae659c3a42805171a8b5be8e87',
            product: 'PRO_MULTISITE',
            initialState: 'notify',
            rejectButton: true,
            necessaryCookies: [".AspNetCore.*", "ARRAffinity", 'ASP.NET_SessionId'],
            text: civicCookieConfig.Text(lang),
            statement: civicCookieConfig.Statement(lang),
            optionalCookies: [
                {
                    name: 'analytics',
                    label: civicCookieConfig.AnalyticsLabel(lang),
                    description: civicCookieConfig.AnalyticsDescription(lang),
                    cookies: ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv'],
                    recommendedState: true,
                    onAccept: function () {
                        window.dataLayer = window.dataLayer || [];
                        function gtag() { dataLayer.push(arguments); }
                        gtag('js', new Date());
                        gtag('config', gtagCode);

                    },
                    onRevoke: function () {
                        window['ga-disable-' + gtagCode] = true;
                    }
                }
            ]
        }
    },
    Statement: function (lang) {
        return lang === civicCookieConfig.WELSHCODE()
            ? {
                description: ' ',
                name: 'Darllenwch ein polisi preifatrwydd am ragor o wybodaeth.',
                url: 'https://senedd.cymru/cy/help/privacy/Pages/privacy.aspx',
                updated: '26/01/2018'
            }
            : {
                description: ' ',
                name: 'For more information visit our privacy policy',
                url: 'https://senedd.wales/en/help/privacy/Pages/privacy.aspx',
                updated: '26/01/2018'
            };
    },
    Text: function (lang) {
        return lang === civicCookieConfig.WELSHCODE()
            ? {
                title: 'Mae’r wefan hon yn defnyddio cwcis.',
                intro: 'Mae rhai o’r cwcis hyn yn hanfodol, ac mae eraill yn ein helpu i wella’ch profiad.',
                acceptRecommended: 'Derbyn',
                rejectSettings: 'Gwrthod pob un',
                necessaryTitle: 'Cwcis angenrheidiol',
                necessaryDescription: 'Mae cwcis angenrheidiol yn galluogi ymarferoldeb craidd',
                thirdPartyTitle: '(W)Warning: Some cookies require your attention',
                thirdPartyDescription: '(W)Please follow the link(s) below to opt out manually.',
                on: 'Ymlaen',
                off: 'I ffwrdd',
                notifyTitle: 'Eich dewis ynghylch cwcis ar y wefan',
                notifyDescription:
                    'Rydym yn defnyddio cwcis i wneud y gorau o ymarferoldeb y wefan a rhoi’r profiad gorau posibl i chi.',
                accept: 'Derbyn',
                reject: 'Gwrthod',
                settings: 'Dewisiadau cwcis',
                closeLabel: 'Caewch',
                accessibilityAlert:
                    '(W)This site uses cookies to store information. Press accesskey C to learn more about your options.'
            }
            : {
                title: 'This site uses cookies.',
                intro: 'Some of these cookies are essential, while others help us to improve your experience.',
                acceptRecommended: 'I Accept',
                rejectSettings: 'Reject All',
                necessaryTitle: 'Necessary Cookies',
                necessaryDescription: 'Necessary cookies enable core functionality..',
                thirdPartyTitle: 'Warning: Some cookies require your attention',
                thirdPartyDescription: 'Please follow the link(s) below to opt out manually.',
                on: 'On',
                off: 'Off',
                notifyTitle: 'Your choice regarding cookies on this site',
                notifyDescription:
                    'We use cookies to optimise site functionality and give you the best possible experience.',
                accept: 'Accept',
                reject: 'Reject',
                settings: 'Cookie Preferences',
                closeLabel: 'Close',
                accessibilityAlert:
                    'This site uses cookies to store information. Press accesskey C to learn more about your options.'
            };

    },
    AnalyticsLabel: function (lang) {
        return lang === civicCookieConfig.WELSHCODE()
            ? 'Dadansoddeg' :
            'Analytics';
    },
    AnalyticsDescription: function (lang) {
        return lang === civicCookieConfig.WELSHCODE()
            ? 'Mae cwcis dadansoddol yn ein helpu i wella ein gwefan drwy gasglu ac adrodd gwybodaeth am ei defnydd.' :
            'Analytical cookies help us to improve our website by collecting and reporting information on its usage.';
    },
    WELSHCODE: () => 'cy'
}

$(function () {
    CookieControl.load(civicCookieConfig.Config(
        $("input[name='civiccookielang']").val(),
        $("input[name='civiccookiegtag']").val()));
});